import React from "react";
import "./SuccessModal.css";
import { CheckCircle } from "lucide-react"; // lightweight icon

export default function SuccessModal({ show, onClose, reservation }) {
  if (!show) return null;

  return (
    <div className="success-modal-overlay" onClick={onClose}>
      <div
        className="success-modal"
        onClick={(e) => e.stopPropagation()} // prevent closing on inner click
      >
        <CheckCircle className="success-icon" />
        <h2>Reservation Confirmed!</h2>
        <p>Thank you for booking with us, {reservation.name}.</p>

        <div className="reservation-details">
          <p>
            <strong>Date:</strong> {reservation.date}
          </p>
          <p>
            <strong>Time:</strong> {reservation.time}
          </p>
          <p>
            <strong>Guests:</strong> {reservation.guests}
          </p>
          <p>
            Tables are held for 15 minutes after the reservation time. After that, your booking may be cancelled.
          </p>
        </div>

        <button onClick={onClose} className="close-btn">
          Close
        </button>
      </div>
    </div>
  );
}
